import { connect } from "react-redux";
import get from "lodash/get";
import { bindActionCreators } from "redux";
import CollapsableHolidaySummary from "app/pages/Booking/HolidaySummary/CollapsableHolidaySummary/CollapsableHolidaySummary";
import {
	calculatePreBookTotal,
	getOffer,
	getQuoteTotalWithDelta,
} from "app/pages/Booking/bookingSelectors";
import { matchPath, withRouter } from "react-router-dom";
import { PAYMENT_OPTIONS } from "app/constants";
import { getEcheancierCasino } from "app/pages/Booking/Payment/paymentSelector";

const mapStateToProps = (state, ownProps) => {
	const selectedOffer = getOffer(state);

	const currentPathname = ownProps.location.pathname;

	const isPaymentPage = matchPath(currentPathname, {
		path: "/booking/payment",
	});

	const isSDPPaymentPage = matchPath(currentPathname, {
		path: "/sdp/booking/payment",
	});

	const booking = state.booking || {};

	const paymentMode = booking.paymentMode;

	const is4xPayment = paymentMode === PAYMENT_OPTIONS["4x"];

	const mensualite = getEcheancierCasino(state);

	const paymentTotal = getQuoteTotalWithDelta(state);

	const paymentTotalWithCreditFees = is4xPayment
		? paymentTotal + mensualite.coutCredit
		: paymentTotal;

	const total =
		isPaymentPage || isSDPPaymentPage
			? paymentTotalWithCreditFees
			: calculatePreBookTotal(state);

	return {
		offerType: get(selectedOffer, "type"),
		totalPrice: total,
		coutCredit: mensualite.coutCredit,
	};
};

const mapDispatchToProps = dispatch => {
	return bindActionCreators({}, dispatch);
};

export default withRouter(
	connect(
		mapStateToProps,
		mapDispatchToProps
	)(CollapsableHolidaySummary)
);
